export default __webpack_public_path__ + "static/media/voorbeeld-binnenhof-hoog-cropped.3838d91d.jpg";